import { render, staticRenderFns } from "./InMapLegendList.vue?vue&type=template&id=b98f1d4a"
import script from "./InMapLegendList.vue?vue&type=script&lang=js"
export * from "./InMapLegendList.vue?vue&type=script&lang=js"
import style0 from "./InMapLegendList.vue?vue&type=style&index=0&id=b98f1d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports